import React from "react";
import { FiCheck } from "react-icons/fi";
import { motion } from "framer-motion";

const ServicePoints = ({ title, desc, points = [] }) => {
  if (!title && points.length === 0) return null;

  // Section variants
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, when: "beforeChildren", staggerChildren: 0.3 },
    },
  };

  // List item variants
  const pointVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  return (
    <motion.section
      className="info-bottom"
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      {title && <motion.h2 className="section-title">{title}</motion.h2>}
      {desc && <motion.p>{desc}</motion.p>}

      <ul className="info-points">
        {points.map((item, index) => (
          <motion.li
            key={index}
            variants={pointVariants}
            whileHover="hover"
            className="info-point-item"
          >
            <span className="check-icon">
              <FiCheck />
            </span>

            <div className="point-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </motion.li>
        ))}
      </ul>
    </motion.section>
  );
};

export default ServicePoints;
